import {
    Box,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerOverlay,
    Stack,
    Link,
    InputGroup,
    Input,
    InputRightElement,
    Text, Spinner, IconButton, FormControl,
} from '@chakra-ui/react';
import React, {useState} from 'react';
import {atom, useRecoilState} from 'recoil';
import {HBmenuSvg, SearchSvg, RightAnchorSvg} from '../assets';
import linksOption, {socialMediaOption} from '../constants/links';
import {Link as RouterLink} from 'react-router-dom';
import colorAlpha from 'color-alpha';
import {motion} from 'framer-motion';
import axios from "axios";

const MotionedSvg = motion(RightAnchorSvg);
const MotionedLink = motion(Link);

const hmMenuState = atom({
    key: 'hm-menu__state',
    default: false,
});

const HMMenu = () => {
    const [searchResults, setSearchResults] = useState(false)
    const [submitted, setSubmitted] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const [open, setOpen] = useRecoilState(hmMenuState);
    return (
        <>
            <Box onClick={() => setOpen(!open)} cursor={'pointer'}>
                <HBmenuSvg/>
            </Box>
            <Drawer
                isOpen={open}
                placement="right"
                onClose={() => setOpen(!open)}
                preserveScrollBarGap
            >
                <DrawerOverlay/>
                <DrawerContent
                    maxW={['100%', '542px']}
                    bgColor={'brand.700'}
                    bottom={[0]}
                >
                    <DrawerCloseButton
                        bgColor={'brand.700'}
                        borderRadius={'full'}
                        color={'white'}
                        size={'lg'}
                        _focus={{
                            boxShadow: 'none',
                        }}
                        _active={{
                            backgroundColor: 'brand.700 !important',
                        }}
                        _hover={{
                            backgroundColor: 'brand.700 !important',
                        }}
                        sx={{
                            top: [30, 50],
                            right: [30, 50],
                            '& svg': {
                                width: 21,
                                height: 21,
                            },
                        }}
                    />

                    <DrawerBody
                        display={'flex'}
                        flexDirection={'column'}
                        pb={['1', '3.5']}
                        p={['40px', '60px']}
                    >
                        <Stack
                            mt={['111px', '73px']}
                            width={'fit-content'}
                            spacing={0}
                            sx={{
                                '& a:not(:last-child)': {
                                    mb: '1.875rem !important',
                                },
                                '& a:focus': {
                                    boxShadow: 'none !important',
                                },
                            }}
                            direction={'column'}
                        >
                            {linksOption.map((item, idx) => {
                                if (item.external) {
                                    return (
                                        <MotionedLink
                                            w={'fit-content'}
                                            fontWeight={'semibold'}
                                            lineHeight={'3rem'}
                                            letterSpacing={'-1px'}
                                            fontSize={'5xl'}
                                            to={item.external ? undefined : item.href}
                                            href={item.external ? item.href : undefined}
                                            key={idx}
                                            isExternal={item.external}
                                            color={colorAlpha('#F3F5F5', 0.6)}
                                            position={'relative'}
                                            onClick={() => setOpen(!open)}
                                            _hover={{
                                                color: 'white',
                                            }}
                                            _focus={{
                                                boxShadow: 'none'
                                            }}
                                            sx={{
                                                '&:hover:before': {
                                                    position: 'absolute',
                                                    bottom: '9px',
                                                    left: '-10px',
                                                    height: '1px',
                                                    backgroundColor: 'white',
                                                    opacity: 0.6,
                                                    width: '110%',
                                                    transition: 'width 0.4s ease',
                                                },
                                                '&:before': {
                                                    content: "''",
                                                    width: '0%',
                                                },
                                                '&:hover:after': {
                                                    position: 'absolute',
                                                    top: '3px',
                                                    right: '-10px',
                                                    height: '1px',
                                                    backgroundColor: 'white',
                                                    opacity: 0.6,
                                                    width: '110%',
                                                    transition: 'width 0.4s ease',
                                                },
                                                '&:after': {
                                                    content: "''",
                                                    width: '0%',
                                                },
                                                '&:hover span': {
                                                    position: 'absolute',
                                                    left: '3px',
                                                    top: '-6px',
                                                    backgroundColor: 'white',
                                                    opacity: '0.6',
                                                    transition: 'height 0.4s ease',
                                                    width: '1px',
                                                    height: '110%',
                                                },
                                                '&:hover svg': {
                                                    opacity: '1 !important',
                                                    top: '12px !important',
                                                    right: '-50px !important',
                                                    transform: 'rotate(180deg) !important',
                                                },
                                            }}
                                            as={item.external ? undefined : RouterLink}
                                            display={'flex'}
                                            alignItems={'center'}
                                        >
                                            <Box as="span" height={'0'}/>
                                            {item.title}
                                            <MotionedSvg
                                                style={{
                                                    transform: 'rotate(190deg)',
                                                    opacity: 0,
                                                    position: 'absolute',
                                                    top: 20,
                                                    right: -58,
                                                    transition: 'all 0.4s ease',
                                                }}
                                                fill="white"
                                            />
                                        </MotionedLink>
                                    )
                                }
                                return (
                                    <MotionedLink
                                        w={'fit-content'}
                                        fontWeight={'semibold'}
                                        lineHeight={'3rem'}
                                        letterSpacing={'-1px'}
                                        fontSize={'5xl'}
                                        to={item.href}
                                        key={idx}
                                        color={colorAlpha('#F3F5F5', 0.6)}
                                        position={'relative'}
                                        onClick={() => setOpen(!open)}
                                        _hover={{
                                            color: 'white',
                                        }}
                                        _focus={{
                                            boxShadow: 'none'
                                        }}
                                        sx={{
                                            '&:hover:before': {
                                                position: 'absolute',
                                                bottom: '9px',
                                                left: '-10px',
                                                height: '1px',
                                                backgroundColor: 'white',
                                                opacity: 0.6,
                                                width: '110%',
                                                transition: 'width 0.4s ease',
                                            },
                                            '&:before': {
                                                content: "''",
                                                width: '0%',
                                            },
                                            '&:hover:after': {
                                                position: 'absolute',
                                                top: '3px',
                                                right: '-10px',
                                                height: '1px',
                                                backgroundColor: 'white',
                                                opacity: 0.6,
                                                width: '110%',
                                                transition: 'width 0.4s ease',
                                            },
                                            '&:after': {
                                                content: "''",
                                                width: '0%',
                                            },
                                            '&:hover span': {
                                                position: 'absolute',
                                                left: '3px',
                                                top: '-6px',
                                                backgroundColor: 'white',
                                                opacity: '0.6',
                                                transition: 'height 0.4s ease',
                                                width: '1px',
                                                height: '110%',
                                            },
                                            '&:hover svg': {
                                                opacity: '1 !important',
                                                top: '12px !important',
                                                right: '-50px !important',
                                                transform: 'rotate(180deg) !important',
                                            },
                                        }}
                                        as={RouterLink}
                                        display={'flex'}
                                        alignItems={'center'}
                                    >
                                        <Box as="span" height={'0'}/>
                                        {item.title}
                                        <MotionedSvg
                                            style={{
                                                transform: 'rotate(190deg)',
                                                opacity: 0,
                                                position: 'absolute',
                                                top: 20,
                                                right: -58,
                                                transition: 'all 0.4s ease',
                                            }}
                                            fill="white"
                                        />
                                    </MotionedLink>
                                )
                            })}
                        </Stack>

                        <Box mt={'auto'} maxWidth={'90%'}>
                            
                            <Box
                                display={'flex'}
                                flexDirection={'column'}
                                width={['auto', '256px']}
                                textAlign={'left'}
                                mr={['0', '3.7rem']}
                                pb={'2rem'}
                            >
                                <Text
                                    textColor={'whiteAlpha.600'}
                                    fontSize={'xs'}
                                    fontWeight={'semibold'}
                                    lineHeight={'10px'}
                                    textTransform={'uppercase'}
                                    mb={'2'}
                                >
                                    follow us
                                </Text>
                                {socialMediaOption.map((item, idx, key) => {
                                    return (
                                        <Link
                                            href={item.href}
                                            textColor={'white'}
                                            fontSize={'md'}
                                            fontWeight={'semibold'}
                                            lineHeight={'6'}
                                            key={idx}
                                        >
                                            {item.title}
                                        </Link>
                                    );
                                })}
                            </Box>
                        </Box>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    );
};
export default HMMenu;
